import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { catchError, EMPTY, map } from 'rxjs';

@Component({
  selector: 'app-assign-agents',
  templateUrl: './assign-agents.component.html',
  styleUrls: ['./assign-agents.component.scss'],
})
export class AssignAgentsComponent implements OnChanges {
  assignedAgents: any = [];
  @Input()
  details: any;

  @Output() assignedAgentIds = new EventEmitter<any>();
  @Output() modifiedQueueData = new EventEmitter<any>();
  @Output() modifiedSkillData = new EventEmitter<any>();
  priorityModel: any = '';
  persistenceModel: any = '';
  roleModel: any;
  showIt: boolean = false;
  leftHeader = '';
  rightHeader = '';

  agentListInGroups: any = [];

  viewReady = false;
  selectedAgents: any;
  selectedAssignedAgents: any;
  availableDisplay: any = [];
  filteredAvailableDisplay: any = [];
  assignedDisplay: any = [];
  agentGroups: any = null;
  originalData: any = null;
  modifiedData: any = [];
  selectedGroup: any = { label: 'All Group' };
  search: any = '';

  count: any = { availableCount: 0, assignedCount: 0 };

  //viewReady = false;
  dataLoaded = false;
  objectType: any = null;
  ownerType: any = null;
  service = null;
  getMethod = null;
  disabled = false;
  groupUserRoles = null;
  hasPriorities = false;
  hasPersistence = false;
  hasGroupUserRoles = false;
  canViewTestQueues: boolean = false;
  objectID = null;

  constructor(
    private managerService: ManagerService,
    private utils: Utils,
    private appService: AppService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['details'].currentValue != undefined &&
      changes['details'].previousValue != changes['details'].currentValue
    ) {
      this.objectID = changes['details'].currentValue.ID;
      this.ownerType =
        typeof changes['details'].currentValue.owner === 'string' ? changes['details'].currentValue.owner : null;
      this.objectType =
        typeof changes['details'].currentValue.object === 'string' ? changes['details'].currentValue.object : null;

      this.service =
        typeof changes['details'].currentValue.service != 'undefined' ? changes['details'].currentValue.service : null;
      this.getMethod =
        typeof changes['details'].currentValue.getMethod === 'string'
          ? changes['details'].currentValue.getMethod
          : null;

      this.hasPriorities = changes['details'].currentValue.priorities === true;
      this.hasPersistence = changes['details'].currentValue.persistence === true;
      this.hasGroupUserRoles = changes['details'].currentValue.roles === true;
      this.disabled = changes['details'].currentValue.disable === true;
      this.init();
      if (this.ownerType == 'skill') {
        this.loadSkillAgents(this.objectID);
      }
      if (this.ownerType == 'group') {
        this.loadGroupUsers(this.objectID);
      }
      if (this.ownerType == 'agent' && this.objectType == 'queue') {
        this.loadAgentQueues(this.objectID);
      }
      if (this.ownerType == 'agent' && this.objectType == 'skill') {
        this.loadAgentSkills(this.objectID);
      }
      if (this.ownerType == 'queue' && this.objectType == 'agent') {
        this.loadQueueAgents(this.objectID);
      }
    }
  }

  init() {
    if (this.hasGroupUserRoles && this.service) {
      this.loadGroupUserRoles();
    } else if (this.objectType.toLowerCase() == 'queue') {
      this.canViewTestQueues = true;
      this.initializeView();
    } else this.initializeView();
  }
  initializeView() {
    if (this.originalData != null && this.viewReady) {
      this.updateData(this.objectID, this.originalData);
      this.loadAgentGroups();
    }
  }
  loadAgentGroups() {
    this.agentGroups = [{ label: 'All Group' }];

    for (const item of this.availableDisplay) {
      if (item.isGroup) this.agentGroups.push(item);
    }
  }
  loadGroupUserRoles() {
    this.managerService
      .GetGroupUserRoles()
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetGroupUserRoles');
          if (isValid) {
            this.groupUserRoles = data.Response.Data;
            this.viewReady = true;
            this.initializeView();
            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  loadGroupUsers(id: any) {
    this.managerService
      .GetGroupUsers(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetGroupUsers');
          if (isValid) {
            this.originalData = data.Response.Data;
            this.initializeView();

            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  selectByGroup(value: any) {
    this.selectByGroupValue(value.value);
  }

  selectByGroupValue(value: string) {
    const res = this.loadGroupItems(this.agentListInGroups, true);
    this.filteredAvailableDisplay = res.availableDisplay;
    this.clearSelectedAgents();
  }
  loadAgentQueues(id: any) {
    this.managerService
      .GetAgentQueues(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetAgentQueues');
          if (isValid) {
            this.originalData = data.Response.Data;
            this.viewReady = true;
            this.initializeView();

            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  loadAgentSkills(id: any) {
    this.managerService
      .GetAgentSkills(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetAgentSkills');
          if (isValid) {
            this.originalData = data.Response.Data;
            this.viewReady = true;
            this.initializeView();

            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  loadQueueAgents(id: any) {
    this.managerService
      .GetQueueAgents(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetQueueAgents');
          if (isValid) {
            this.originalData = data.Response.Data;
            this.viewReady = true;
            this.initializeView();

            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  clearSelectedAgents() {
    //// alert("test")
    const test1 = structuredClone(this.availableDisplay);
    this.availableDisplay = [];
    this.availableDisplay = test1;
  }
  isFilterMatch(text: any) {
    text = text.toLowerCase();
    if (this.objectType.toLowerCase() == 'agent' || this.objectType.toLowerCase() == 'user') {
      text = text.split(' ');
      for (let i = 0; i < text.length; i++) {
        if (text[i].indexOf(this.search.toLowerCase()) == 0) return true;
      }
      this.clearSelectedAgents();
      return false;
    } else {
      //this.clearSelectedAgents();
      return text.indexOf(this.search.toLowerCase()) == 0;
    }
  }

  applyFilterByName(event: any) {
    //alert(event.value);
    const res = this.loadGroupItems(this.agentListInGroups, true);
    this.filteredAvailableDisplay = res.availableDisplay;
  }
  isFilterMatchByGroup(options: any) {
    let count = 0;
    for (let i = 0; i < options.length; i++) {
      if (this.isFilterMatch(options[i].label)) {
        count++;
      }
    }
    return count;
  }
  updateData(id: any, data: any) {
    this.objectID = id;
    this.modifiedData = structuredClone(data);
    this.availableDisplay = [];
    this.assignedDisplay = [];
    this.agentListInGroups = [];
    this.setHeaders();
    this.showMetaContainer(
      this.hasPriorities,
      this.hasPersistence,
      this.hasGroupUserRoles,
      this.groupUserRoles,
      this.disabled
    );
    if (this.modifiedData && this.modifiedData.length > 0) {
      for (let i = 0; i < this.modifiedData.length; i++) {
        const row = this.modifiedData[i];
        const tooltip = this.getTooltip(this.modifiedData[i]);
        const group =
          this.objectType.toLowerCase() == 'agent' ? (row.Group == null ? 'No Group' : row.Group) : row.Type;
        if (!(this.objectType.toLowerCase() == 'queue' && row.Testing && !this.canViewTestQueues))
          this.addOption(
            this.agentListInGroups,
            row.Name + ('AssignedCount' in row ? ' (' + row.AssignedCount + ')' : ''),
            row.ID,
            group,
            tooltip,
            row.Assigned,
            false
          );
      }
      this.sortOptions(this.agentListInGroups);
      //uncomment later  this.addOption(this.agentListInGroups, "No search results found", -1, null, "No search results found. Modify your search and try again.", false, false);
      //this.agentListInGroups.resultsFound = true;
      //this.availableDisplay = structuredClone(this.agentListInGroups);
      //$(this.availableSelect).children('option:last-child').css('display', 'none');
      // this.showGroupsFilter(this.objectType.toLowerCase() == "agent");
      //   this.assignedSelect = structuredClone(this.availableSelect);

      const res: any = this.loadGroupItems(this.agentListInGroups, false);
      this.availableDisplay = res.availableDisplay;
      this.assignedDisplay = res.assignedDisplay;
      this.filteredAvailableDisplay = res.availableDisplay;
      this.setOutputData();
      //this.appService.setmodifiedQueueData(this.modifiedQueueData);
     // console.log(this.modifiedQueueData);
    }
    this.setCounts();
  }

  setHeaders() {
    if (this.ownerType != null && this.objectType != null) {
      const owner = this.ownerType.split(/(?=[A-Z])/).join(' ');
      const object = this.objectType.split(/(?=[A-Z])/).join(' ');
      this.leftHeader = 'Available ' + this.utils.initialUpper(this.utils.pluralize(object));
      this.rightHeader =
        this.utils.initialUpper(owner) + "'s Assigned " + this.utils.initialUpper(this.utils.pluralize(object));
    }
  }
  showMetaContainer(priorities: boolean, persistence: boolean, groupUser: any, roles: any, disable: any) {
    this.hasPriorities = priorities;
    this.hasPersistence = persistence;
    this.hasGroupUserRoles = groupUser;
    this.groupUserRoles = roles;
    this.disabled = disable;

    this.showIt = (this.hasPriorities || this.hasPersistence || this.hasGroupUserRoles) && !this.disabled;
  }

  getPriorityValue(label: any) {
    const matchStart = ' - Priority ';
    if (label.lastIndexOf(matchStart) != -1) {
      label = label.substring(label.lastIndexOf(matchStart) + matchStart.length);
      return parseInt(label.split(' ')[0]);
    } else return 0;
  }

  getPersistence = function (label: any) {
    return label.lastIndexOf(' - Temporary') == -1;
  };

  apply() {
    //roleModel
    const selectedOptions = this.selectedAssignedAgents;
    if (selectedOptions.length > 0) {
      // priorityText.value($.trim(priorityText.value()));
      let priorityValue = this.priorityModel;
      if (
        this.hasPriorities &&
        priorityValue.length > 0 &&
        (!/^[1-9][0-9]*$/.test(priorityValue) || parseInt(priorityValue) > 10)
      ) {
        alert(
          '<strong>Invalid Priority</strong><br />Please enter a number between 1 and 10,<br />or leave it blank to have no effect.'
        ); //, function () {
        // alertModal.close();
        //   });
      } else {
        priorityValue = isNaN(priorityValue) || priorityValue.length == 0 ? 0 : parseFloat(priorityValue);
        if (this.hasGroupUserRoles && this.roleModel == 2 && selectedOptions.length > 1) {
          alert('<strong>Sorry</strong><br />Only one user can be<br />designated as Manager per group.'); //, function () {
          //     alertModal.close();
          // });
        } else if (priorityValue % 1 == 0 && priorityValue >= 0) {
          this.applyMetaToSelected(this.assignedDisplay, priorityValue, !this.persistenceModel, this.roleModel);
        }
      }
    } else {
      this.applyMetaToSelected(this.assignedDisplay, null, null, null);
    }
  }
  clear() {
    this.priorityModel = 0;
    this.persistenceModel = false;
    this.apply();
  }
  loadGroupItems(groups: any, isFilter: boolean) {
    const displayVals = { availableDisplay: [], assignedDisplay: [] };
    //this.availableDisplay = [];
    //this.assignedDisplay = [];
    const hasGroups = this.selectHasGroups(groups);
    if (hasGroups) {
      for (let i = 0; i < groups.length; i++) {
        if (isFilter) {
          if (groups[i].label == this.selectedGroup.label || this.selectedGroup.label == 'All Group') {
            const availableOptions: any = [];
            const assignedOptions: any = [];

            for (let j = 0; j < groups[i].options.length; j++) {
              if (groups[i].options[j].selected == true) {
                assignedOptions.push({
                  label: groups[i].options[j].label,
                  selected: groups[i].options[j].selected,
                  tooltip: groups[i].options[j].tooltip,
                  value: groups[i].options[j].value,
                });
              } else if (groups[i].options[j].selected == false) {
                if (this.isFilterMatch(groups[i].options[j].label))
                  availableOptions.push({
                    label: groups[i].options[j].label,
                    selected: groups[i].options[j].selected,
                    tooltip: groups[i].options[j].tooltip,
                    value: groups[i].options[j].value,
                  });
              }
            }

            if (assignedOptions.length > 0)
              displayVals.assignedDisplay.push({
                isGroup: groups[i].isGroup,
                label: groups[i].label,
                options: assignedOptions,
              });
            if (availableOptions.length > 0)
              displayVals.availableDisplay.push({
                isGroup: groups[i].isGroup,
                label: groups[i].label,
                options: availableOptions,
              });
          }
        } else {
          const availableOptions: any = [];
          const assignedOptions: any = [];

          for (let j = 0; j < groups[i].options.length; j++) {
            if (groups[i].options[j].selected == true) {
              assignedOptions.push({
                label: groups[i].options[j].label,
                selected: groups[i].options[j].selected,
                tooltip: groups[i].options[j].tooltip,
                value: groups[i].options[j].value,
              });
            } else if (groups[i].options[j].selected == false) {
              if (this.isFilterMatch(groups[i].options[j].label))
                availableOptions.push({
                  label: groups[i].options[j].label,
                  selected: groups[i].options[j].selected,
                  tooltip: groups[i].options[j].tooltip,
                  value: groups[i].options[j].value,
                });
            }
          }

          if (assignedOptions.length > 0)
            displayVals.assignedDisplay.push({
              isGroup: groups[i].isGroup,
              label: groups[i].label,
              options: assignedOptions,
            });
          if (availableOptions.length > 0)
            displayVals.availableDisplay.push({
              isGroup: groups[i].isGroup,
              label: groups[i].label,
              options: availableOptions,
            });
        }
      }
    } else {
      const availableOptions: any = [];
      const assignedOptions: any = [];
      for (let i = 0; i < groups.length; i++) {
        //opt.group = (hasGroups) ? getOptionGroupNameByValue(fromSelect, opt.value) : null;
        // addOption(toSelect, label, opt.value, opt.group, opt.title, maintainSelection);

        if (groups[i].selected == true) {
          assignedOptions.push({
            label: groups[i].label,
            selected: groups[i].selected,
            tooltip: groups[i].tooltip,
            value: groups[i].value,
          });
        } else if (groups[i].selected == false) {
          if (this.isFilterMatch(groups[i].label))
            availableOptions.push({
              label: groups[i].label,
              selected: groups[i].selected,
              tooltip: groups[i].tooltip,
              value: groups[i].value,
            });
        }
      }
      if (assignedOptions.length > 0) displayVals.assignedDisplay = assignedOptions;
      if (availableOptions.length > 0) displayVals.availableDisplay = availableOptions;
    }
    if (hasGroups) {
      for (let i = 0; i < displayVals.assignedDisplay.length; i++) {
        for (let j = 0; j < displayVals.assignedDisplay[i].options.length; j++) {
          if (this.modifiedData) {
            const item = this.getFromArray(this.modifiedData, displayVals.assignedDisplay[i].options[j].value, 'ID');
            const priority = this.hasPriorities ? item.Priority : null;
            const persistence = this.hasPersistence ? item.Persistent : false;
            const groupRole = this.hasGroupUserRoles ? item.GroupUserRoleID : null;
            displayVals.assignedDisplay[i].options[j].label = this.getMetaLabel(
              displayVals.assignedDisplay[i].options[j].value,
              priority,
              persistence,
              groupRole,
              null
            );
          } else {
            displayVals.assignedDisplay[i].options[j].label = this.getMetaLabel(
              displayVals.assignedDisplay[i].options[j].value,
              null,
              false,
              this.hasGroupUserRoles ? 1 : null,
              null
            );
          }
          // this.assignedDisplay[i].options[j].group = (hasGroups) ? this.getOptionGroupNameByValue(this.availableDisplay, this.assignedDisplay[i].options[j].value) : null;
          //this.addOption(toSelect, label, opt.value, opt.group, opt.title, maintainSelection);
        }
      }
    } else {
      for (let i = 0; i < displayVals.assignedDisplay.length; i++) {
        if (this.modifiedData) {
          const item = this.getFromArray(this.modifiedData, displayVals.assignedDisplay[i].value, 'ID');
          const priority = this.hasPriorities ? item.Priority : null;
          const persistence = this.hasPersistence ? item.Persistent : false;
          const groupRole = this.hasGroupUserRoles ? item.GroupUserRoleID : null;
          displayVals.assignedDisplay[i].label = this.getMetaLabel(
            displayVals.assignedDisplay[i].value,
            priority,
            persistence,
            groupRole,
            null
          );
        } else {
          displayVals.assignedDisplay[i].label = this.getMetaLabel(
            displayVals.assignedDisplay[i].value,
            null,
            false,
            this.hasGroupUserRoles ? 1 : null,
            null
          );
        }
        // this.assignedDisplay[i].group = (hasGroups) ? this.getOptionGroupNameByValue(this.availableDisplay, this.assignedDisplay[i].value) : null;
      }
    }

    //alert(JSON.stringify(this.assignedDisplay))
    return displayVals;
  }

  // Meta Data Routines
  applyMetaToSelected(uiSelect: any, priorityValue: any, isPersistent: any, groupUserRole: any) {
    if (this.hasPriorities || this.hasPersistence || this.hasGroupUserRoles) {
      const selectedOptions = this.selectedAssignedAgents;
      if (selectedOptions.length == 0) {
        alert('<strong>Invalid Selection</strong><br />Please select at least one item<br />from the assigned list.'); //, function () {
        //      alertModal.close();
        //   });
      } else {
        const options = uiSelect;
        if (this.selectHasGroups(uiSelect)) {
          for (let i = 0; i < options.length; i++) {
            for (let j = 0; j < options[i].options.length; j++) {
              //options[i].options[j].selected = false;
              if (
                this.hasGroupUserRoles &&
                groupUserRole == 2 &&
                options[i].options[j].label.indexOf('(Manager)') != -1
              ) {
                options[i].options[j].label = this.getMetaLabel(options[i].options[j].value, null, null, 1, null);
              }
              for (let k = 0; k < selectedOptions.length; k++) {
                if (options[i].options[j].value == selectedOptions[k].value) {
                  options[i].options[j].label = this.getMetaLabel(
                    options[i].options[j].value,
                    priorityValue,
                    isPersistent,
                    groupUserRole,
                    this.getPriorityValue(options[i].options[j].label)
                  );
                  //options[i].options[j].selected = true;
                }
              }
            }
          }
        } else {
          for (let i = 0; i < options.length; i++) {
            //options[i].selected = false;
            if (this.hasGroupUserRoles && groupUserRole == 2 && options[i].label.indexOf('(Manager)') != -1) {
              options[i].label = this.getMetaLabel(options[i].value, null, null, 1, null);
            }
            for (let k = 0; k < selectedOptions.length; k++) {
              if (options[i].value == selectedOptions[k].value) {
                options[i].label = this.getMetaLabel(
                  options[i].value,
                  priorityValue,
                  isPersistent,
                  groupUserRole,
                  this.getPriorityValue(options[i].label)
                );
                //options[i].selected = true;
              }
            }
          }
        }

        this.updateFields();
        // uiSelect = data;
        //redrawSelect(uiSelect);
        // updateAssignedStyling(uiSelect);
      }
    }
  }
  updateFields() {
    for (const agent of this.assignedDisplay) {
      for (const option of agent.options) {
        const index = this.getArrayIndex(this.modifiedData, option.value, 'ID');
        this.modifiedData[index].Assigned = true;
        if (this.hasGroupUserRoles) {
          this.modifiedData[index].GroupUserRoleID = this.getUserRole(option.label);
        }
        if (this.hasPersistence) {
          this.modifiedData[index].Persistent = this.getPersistence(option.label);
        }
        if (this.hasPriorities) {
          this.modifiedData[index].Priority = this.getPriorityValue(option.label);
        }
      }
    }
    this.setOutputData();
  }
  setOutputData() {
    if (this.ownerType == 'agent' && this.objectType == 'queue') {
      this.modifiedQueueData.emit(this.modifiedData.filter(modified => modified.Assigned == true));

      this.appService.setmodifiedQueueData(this.modifiedData.filter(modified => modified.Assigned == true));
      //console.log(this.modifiedQueueData);
    } else if (this.ownerType == 'agent' && this.objectType == 'skill') {
      this.modifiedSkillData.emit(this.modifiedData.filter(modified => modified.Assigned == true));
    }
  }

  getUserRole(label: any) {
    if (label.lastIndexOf(' (Manager)') > -1) {
      return 2;
    } else return 1;
  }
  setCounts() {
    //leftHeaderCount.text($(availableSelect).find('option').not('.assigned').length - 1);
    // rightHeaderCount.text(assignedSelect.options.length);
    this.count = { availableCount: 0, assignedCount: 0 };
    for (const i of this.modifiedData) {
      if (i.Assigned) {
        this.count.assignedCount++;
      } else {
        this.count.availableCount++;
      }
    }
  }
  updateAvailableStyling(uiSelect: any) {
    const dropDownOptions = uiSelect.options;
    for (let i = 0; i < dropDownOptions.length; i++) {
      let defaultColor = '';
      const customColor = '#b70f0a';
      if (this.objectType.toLowerCase() == 'queue' && this.canViewTestQueues && dropDownOptions[i].value != -1) {
        const option = this.getFromArray(this.modifiedData, dropDownOptions[i].value, 'ID');
        if (option.Testing) defaultColor = '#ff6624';
      }
      dropDownOptions[i].style.color = dropDownOptions[i].label.indexOf(' (0)') == -1 ? defaultColor : customColor;
    }
  }

  getOptionGroupNameByValue(uiSelect: any, value: any) {
    const data = uiSelect;
    if (this.selectHasGroups(uiSelect)) {
      for (let i = 0; i < data.length; i++) {
        const group = data[i];
        if (this.isInArray(group.options, value, 'value')) return group.label;
      }
    }
    return null;
  }
  getMetaLabel(optionValue: any, priorityValue: any, isPersistent: any, groupUserRole: any, currentPriority: any) {
    const option = this.getFromArray(this.modifiedData, optionValue, 'ID');
    let label = optionValue;
    if (option != null) {
      label = option.Name;
    }
    label +=
      (priorityValue == 0 && currentPriority == 0) || priorityValue == null || priorityValue == 0 || !this.hasPriorities
        ? ''
        : ' - Priority ' + (priorityValue != 0 ? priorityValue : currentPriority);
    label += isPersistent || !this.hasPersistence ? '' : ' - Temporary';
    label += !this.hasGroupUserRoles
      ? ''
      : ' (' + this.getFromArray(this.groupUserRoles, groupUserRole, 'ID').Name + ')';
    return label;
  }
  getFromArray(array: any, search: any, propName: any) {
    const index = this.getArrayIndex(array, search, propName);
    if (index != -1) {
      return array[index];
    }
    return null;
  }
  optionExists(uiSelect: any, value: any) {
    const data = uiSelect;
    if (this.selectHasGroups(uiSelect)) {
      for (let i = 0; i < data.length; i++) {
        const group = data[i];
        if (this.isInArray(group.options, value, 'value')) return true;
      }
      return false;
    } else {
      return this.isInArray(data, value, 'value');
    }
  }

  isInArray(array: any, search: any, propName: any) {
    return this.getArrayIndex(array, search, propName) != -1;
  }
  clearDataSelections(uiSelect: any) {
    const data = uiSelect;
    for (let i = 0; i < data.length; i++) {
      if (this.selectHasGroups(uiSelect)) {
        for (let j = 0; j < data[i].options.length; j++) {
          data[i].options[j].selected = false;
        }
      } else {
        data[i].selected = false;
      }
    }
    uiSelect = data;
  }

  getSelectedOptions(uiSelect: any) {
    const selectedOptions = [];
    const dropDownOptions = uiSelect;
    for (let i = 0; i < dropDownOptions.length - 1; i++) {
      for (let j = 0; j < dropDownOptions[i].options.length; j++) {
        if (dropDownOptions[i].options[j].selected) selectedOptions.push(dropDownOptions[i].options[j]);
      }
    }
    return selectedOptions;
  }

  getTooltip(obj: any) {
    let tooltip = this.utils.initialUpper(this.objectType) + ' ' + obj.ID;
    tooltip += '\nName:\t\t' + obj.Name;
    switch (this.objectType.toLowerCase()) {
      case 'user':
      case 'agent':
        tooltip += '\nGroup:\t\t' + (obj.Group == null ? 'None' : obj.Group);
        tooltip += '\nEmail:\t\t' + obj.Email;
        break;
      case 'skill':
        tooltip += '\nDescription:\t' + (obj.Description == null ? 'None' : obj.Description);
        tooltip += '\nStatus:\t\t' + (obj.Enabled ? 'Active' : 'Disabled');
        break;
      case 'queue':
        tooltip += '\nQueue Type:\t' + obj.Type;
        tooltip += '\nDialer Type:\t' + obj.DialerType;
        if (this.canViewTestQueues) tooltip += '\nTesting:\t\t' + (obj.Testing ? 'Yes' : 'No');
        break;
    }
    return tooltip;
  }

  addOption(uiSelect: any, label: string, value: any, group: any, tooltip: any, selected: any, render: any) {
    let data = uiSelect; //$(uiSelect).data('data');
    const option = {
      label: label,
      value: value,
      tooltip: tooltip,
      selected: selected,
    };
    if (typeof data == 'undefined' || data == null) data = [];
    if (typeof group != 'undefined' && group != null) {
      let grpIndex = this.getArrayIndex(data, group, 'label');
      if (grpIndex == -1) {
        grpIndex = data.length;
        data.push({ isGroup: true, label: group, options: [] });
      }
      data[grpIndex].options.push(option);
    } else {
      data.push(option);
    }
  }
  sortOptions(uiSelect: any) {
    let sortedOptions = uiSelect;
    if (this.selectHasGroups(uiSelect)) {
      if (sortedOptions[sortedOptions.length - 1].label == 'No Group')
        sortedOptions[sortedOptions.length - 1].label = 'ZZZ';
      sortedOptions = this.sortObjectsBy(sortedOptions, 'label', true);
      for (let i = 0; i < sortedOptions.length; i++) {
        sortedOptions[i].options = this.sortObjectsBy(sortedOptions[i].options, 'label', true);
      }
      if (sortedOptions[sortedOptions.length - 1].label == 'ZZZ')
        sortedOptions[sortedOptions.length - 1].label = 'No Group';
    } else {
      sortedOptions = this.sortObjectsBy(sortedOptions, 'label', true);
    }
    uiSelect = sortedOptions;
    //redrawSelect(uiSelect);
  }
  selectHasGroups(uiSelect: any) {
    const data = uiSelect;
    return this.getArrayIndex(data, true, 'isGroup') != -1;
  }

  getArrayIndex(array: any, search: any, propName: any) {
    for (let i = 0; i < array.length; i++) {
      if (propName != null) {
        if (array[i][propName] == search) {
          return i;
        }
      } else if (array[i] == search) {
        return i;
      }
    }
    return -1;
  }

  // Array Utilities
  sortObjectsBy(array: any, compare: any, ascendingOrder: any) {
    const useCompareFunc = typeof compare == 'function';
    for (let i = 0; i < array.length - 1; i++) {
      for (let j = i + 1; j < array.length; j++) {
        let swap = false;
        if (useCompareFunc) {
          swap = compare(array[i], array[j], ascendingOrder);
        } else {
          if (ascendingOrder) {
            swap = array[i][compare] > array[j][compare];
          } else {
            swap = array[i][compare] < array[j][compare];
          }
        }
        if (swap) {
          const dummy = array[i];
          array[i] = array[j];
          array[j] = dummy;
        }
      }
    }
    return array;
  }

  moveRight() {
    //get selected items  merge with agent list
    for (let i = 0; i < this.selectedAgents.length; i++) {
      const index = this.getArrayIndex(this.modifiedData, this.selectedAgents[i].value, 'ID');
      this.modifiedData[index].Assigned = true;
      if (this.hasGroupUserRoles) this.modifiedData[index].GroupUserRoleID = 1;
    }
    this.updateData(this.objectID, this.modifiedData);

    this.selectByGroupValue(this.selectedGroup.label);
    // this.apply();
  }
  moveLeft() {
    //get selected items  merge with agent list
    for (let i = 0; i < this.selectedAssignedAgents.length; i++) {
      const index = this.getArrayIndex(this.modifiedData, this.selectedAssignedAgents[i].value, 'ID');
      this.modifiedData[index].Assigned = false;
    }
    this.updateData(this.objectID, this.modifiedData);
    this.selectByGroupValue(this.selectedGroup.label);
  }

  reset() {
    //reset
    this.updateData(this.objectID, this.originalData);
    this.resetAgentGroupDropDown();
  }
  resetAgentGroupDropDown() {
    this.selectedGroup = this.agentGroups[0];
  }

  loadSkillAgents(id: any) {
    this.managerService
      .GetSkillAgents(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetSkillAgents');
          if (isValid) {
            this.originalData = data.Response.Data;
            this.viewReady = true;
            this.initializeView();
            //this.updateData(id, data.Data);
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
}
